import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { useStoreDetails } from 'api/ApiHooks/DiscountCouponsApiHooks';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import Page from 'components/Page';
import PartialPageSpinner from 'components/PartialPageSpinner';
import usePortalId from 'hooks/portal/usePortalId';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  AUTOMATEDCOUPON,
  DISCOUNT_COUPONS_NAVIGATION,
  PATH_USER,
} from 'routes/paths';
import { StoreForm } from './form/StoreForm';
import _ from 'lodash';
import useIfValidityExpired from 'hooks/apps/useIfValidityExpired';
import Notices from '../../../../common/Notices/Notices';

export default function EditStore() {
  useIfValidityExpired(AUTOMATEDCOUPON);
  const { storeId } = useParams<{
    storeId: string;
  }>();
  const { t } = useTranslation();
  const portalId = usePortalId();
  const wooStoreResponse = useStoreDetails(
    Number(portalId),
    Number(storeId),
    AUTOMATEDCOUPON
  );

  if (wooStoreResponse.data === undefined) {
    return <PartialPageSpinner />;
  }
  const wooStoreDetails = wooStoreResponse.data?.data;

  return (
    <Page title={t('edit_store')} className='px-6'>
      <HeaderBreadcrumbs
        heading={t('stores')}
        links={[
          {
            name: t('app_listing'),
            href: PATH_USER.appListing(portalId),
          },
          {
            name: t('store'),
            href: DISCOUNT_COUPONS_NAVIGATION.general.couponStoreListingTabLinks(
              portalId,
              'stores'
            ),
          },
          {
            name: t('edit_store'),
            href: DISCOUNT_COUPONS_NAVIGATION.general.createStore(portalId),
          },
        ]}
      />

      <Notices appName={AUTOMATEDCOUPON} />

      <div className='flex flex-wrap gap-[15%] sm:flex-nowrap'>
        <div className='flex-grow basis-4/6 py-5'>
          <StoreForm
            storeDetails={wooStoreDetails}
            returnUrl={DISCOUNT_COUPONS_NAVIGATION.general.couponStoreListingTabLinks(
              portalId,
              'stores'
            )}
            appCode={AUTOMATEDCOUPON}
          />
        </div>
        <div className='sm:basis-3/6'>
          <Typography variant='h5'>{t('about_store')}</Typography>
          <div className='text-gray-500'>{t('store_content_line_one')}</div>
          <List sx={{ listStyleType: 'disc' }}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText
                  className='text-gray-500'
                  primary={'-  ' + t('store_content_line_two')}
                />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText
                  className='text-gray-500'
                  primary={'-  ' + t('store_content_line_three')}
                />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText
                  className='text-gray-500'
                  primary={'-  ' + t('store_content_line_four')}
                />
              </ListItemButton>
            </ListItem>
          </List>
          <div className='text-gray-500'>{t('store_content_line_five')}</div>
        </div>
      </div>
    </Page>
  );
}
